import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "../lib/api";
import { toast } from "sonner";
import { ArrowLeft, KeyRound, Loader2, MailCheck } from "lucide-react";

const fmtDetail = (d) => (typeof d === "string" ? d : Array.isArray(d) ? d.map(e => e?.msg).filter(Boolean).join(" ") : "Errore, riprova");

function Shell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg p-8">
        <div className="flex items-center gap-3 mb-6">
          <img src="/logo-studio-aragona.png" alt="Studio Aragona" className="w-11 h-11 rounded object-contain" />
          <div><div className="font-display font-bold text-slate-900">Studio Aragona</div><div className="text-xs text-slate-500">SicurDoc</div></div>
        </div>
        <h1 className="font-display text-2xl font-bold text-slate-900 flex items-center gap-2"><KeyRound size={20} /> {title}</h1>
        <p className="text-slate-500 mt-1 text-sm">{subtitle}</p>
        <div className="mt-6">{children}</div>
        <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-900"><ArrowLeft size={14} /> Torna al login</Link>
      </div>
    </div>
  );
}

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await axios.post(`${API_BASE}/auth/forgot-password`, { email }); setDone(true); }
    catch (err) { toast.error(fmtDetail(err?.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Shell title="Password dimenticata" subtitle="Inserisci l'email del tuo account: se è registrata riceverai un link valido 1 ora.">
      {done ? (
        <div className="flex items-start gap-3 bg-emerald-50 border border-emerald-200 rounded-lg p-4 text-sm text-emerald-900" data-testid="forgot-done">
          <MailCheck size={20} className="shrink-0" /> Se l'indirizzo è registrato, riceverai a breve un'email con il link per reimpostare la password. Controlla anche lo spam.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" placeholder="Email"
            className="w-full px-4 py-2.5 border border-slate-300 rounded-lg" />
          <button type="submit" disabled={busy} data-testid="forgot-submit" className="w-full flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-800 text-white font-semibold py-2.5 rounded-lg disabled:opacity-60">
            {busy && <Loader2 size={16} className="animate-spin" />} Invia link di reimpostazione
          </button>
        </form>
      )}
    </Shell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState(""); const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("Minimo 8 caratteri"); return; }
    if (pw !== pw2) { toast.error("Le password non coincidono"); return; }
    setBusy(true);
    try {
      await axios.post(`${API_BASE}/auth/reset-password`, { token, new_password: pw });
      toast.success("Password reimpostata: accedi con la nuova password");
      nav("/login", { replace: true });
    } catch (err) { toast.error(fmtDetail(err?.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  if (!token) return <Shell title="Link non valido" subtitle="Il link di reimpostazione è incompleto. Richiedine uno nuovo." />;
  return (
    <Shell title="Nuova password" subtitle="Scegli una nuova password di almeno 8 caratteri.">
      <form onSubmit={submit} className="space-y-4">
        <input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password" placeholder="Nuova password" className="w-full px-4 py-2.5 border border-slate-300 rounded-lg font-mono" />
        <input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm" placeholder="Conferma nuova password" className="w-full px-4 py-2.5 border border-slate-300 rounded-lg font-mono" />
        <button type="submit" disabled={busy} data-testid="reset-submit" className="w-full flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-800 text-white font-semibold py-2.5 rounded-lg disabled:opacity-60">
          {busy && <Loader2 size={16} className="animate-spin" />} Salva nuova password
        </button>
      </form>
    </Shell>
  );
}
